<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_detail_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle de Requerimiento Adicional</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
						<div v-if="loading" class="d-flex justify-center align-center" style="min-height: 300px;">
							<div class="text-center">
								<v-progress-circular
									indeterminate
									color="#524D4D"
									size="50"
									width="4"
									class="mb-3"
								></v-progress-circular>
								<p class="text-primary">Cargando información...</p>
							</div>
						</div>
						<div v-else>
							<v-row class="mb-3">
								<v-col cols="6" class="py-0">
									<div class="detail-section">
										<div class="d-flex align-center mb-1" style="gap: 10px;">
											<p class="label-text" style="margin-bottom: 0px!important;">Proyecto</p>
											<v-chip
												color="#524D4D"
												text-color="white"
												small
												label
											>
												<p class="font-weight-bold mb-0">LP{{ projectLineNumber }}</p>
											</v-chip>
										</div>
										<p class="value-text font-weight-bold">{{ projectName }}</p>
										<p class="value-text caption">{{ projectAddress }}</p>
									</div>
								</v-col>
								<v-col cols="6" class="py-0">
									<div class="detail-section">
										<p class="label-text mb-1">Cliente</p>
										<p class="value-text font-weight-bold">{{ projectClient }}</p>
									</div>
								</v-col>
							</v-row>

							<v-row class="mb-3">
								<v-col cols="6" class="py-0">
									<div class="detail-section">
										<p class="label-text mb-1">Estado</p>
										<v-chip
											:color="getStatusColor(requestDetail.status)"
											text-color="white"
											small
										>
											{{ getStatusLabel(requestDetail.status) }}
										</v-chip>
									</div>
								</v-col>
								<v-col cols="6" class="py-0">
									<div class="detail-section">
										<p class="label-text mb-1">Fecha de Solicitud</p>
										<p class="value-text">{{ requestDetail.created_at | toDateTime }}</p>
									</div>
								</v-col>
							</v-row>

							<div class="detail-section mb-3">
								<p class="label-text mb-2">Mensaje al Cliente / Descripción</p>
								<div class="message-box">
									<p class="value-text">{{ requestDetail.description }}</p>
								</div>
							</div>

							<div v-if="requestDetail.status == 4 || requestDetail.status == 2" class="mb-3">
								<div style="background: #FFF8F8; border-left: 3px solid #F44336; border-radius: 4px; padding: 12px;">
									<div class="d-flex align-center mb-2" style="gap: 8px;">
										<v-icon small color="#F44336">mdi-alert-circle-outline</v-icon>
										<p class="caption font-weight-bold mb-0" style="color: #F44336;">{{ requestDetail.status == 4 ? 'Rechazo - Motivo' : 'Cancelación - Motivo' }}</p>
									</div>
									<p class="value-text">{{ requestDetail.observation || 'Sin motivo especificado' }}</p>
									<p class="caption mt-2" style="color: #777;">{{ requestDetail.status == 4 ? 'Rechazada' : 'Cancelada' }} el {{ requestDetail.status_response_date | toDate }}</p>
								</div>
							</div>

							<v-row class="mb-3 mt-2">
								<v-col cols="12" class="py-0">
									<div class="detail-section">
										<p class="label-text mb-0">Monto Estimado del adicional</p>
										<p class="value-text">{{ requestDetail.currency_type == 2 ? '$' : '' }}{{ requestDetail.estimated_amount | toThousandFilter }} {{ currencyLabel }}</p>
										<p class="font-weight-normal caption mb-1 mt-2">Considera esto como un estimado, el monto final puede variar.</p>
									</div>
								</v-col>
							</v-row>

							<div v-if="requestDetail.status == 3">
								<v-divider class="my-2"></v-divider>
								<div class="detail-section mb-3">
									<p class="label-text mb-2">Información de Aprobación</p>
									<p class="value-text small-text">Aprobado por el cliente el {{ requestDetail.status_response_date | toDate }}</p>
								</div>
							</div>

							<v-divider class="my-2"></v-divider>

							<div class="d-flex flex-row align-center justify-end" style="gap: 8px;">
								<v-btn
									small
									outlined
									color="#524D4D"
									style="text-transform: none; letter-spacing: 0;"
									@click="toContract"
								>
									<v-icon small left>mdi-file-document-outline</v-icon>
									Ir al Contrato
								</v-btn>
								<v-btn
									v-if="!isProjectClient"
									small
									outlined
									color="#524D4D"
									style="text-transform: none; letter-spacing: 0;"
									@click="toProjectCostBreakdown"
								>
									<v-icon small left>mdi-table</v-icon>
									Ir a Tabla de Costo
								</v-btn>
							</div>

							<!-- Botones de acción principales -->
							<div v-if="requestDetail.status === 1">
								<v-divider class="my-3"></v-divider>
								<div class="d-flex flex-row align-center justify-end" style="gap: 8px;">
									<!-- Responsable: abrir form de cancelación -->
									<v-btn
										v-if="isProjectResponsible && !showCancellationForm"
										small
										outlined
										color="#9E9E9E"
										style="text-transform: none; letter-spacing: 0;"
										@click="openObservationFormForStatus(2)"
									>
										<v-icon small left>mdi-close-circle-outline</v-icon>
										Cancelar solicitud
									</v-btn>

									<!-- Cliente: rechazar / aceptar -->
									<v-btn
										v-if="isProjectClient"
										small
										outlined
										color="#F44336"
										style="text-transform: none; letter-spacing: 0;"
										@click="openObservationFormForStatus(4)"
									>
										<v-icon small left>mdi-close</v-icon>
										Rechazar
									</v-btn>
									<v-btn
										v-if="isProjectClient"
										small
										depressed
										dark
										color="#4CAF50"
										style="text-transform: none; letter-spacing: 0;"
										@click="respondToRequest(3)"
									>
										<v-icon small left>mdi-check</v-icon>
										Aceptar
									</v-btn>
								</div>

								<!-- Form de cancelación -->
								<v-expand-transition>
									<div v-if="showCancellationForm && (isProjectResponsible || isProjectClient)" class="mt-3">
										<div style="background: #FFF8F8; border-left: 3px solid #F44336; border-radius: 4px; padding: 14px;">
											<div class="d-flex align-center mb-2" style="gap: 8px;">
												<v-icon small color="#F44336">mdi-alert-circle-outline</v-icon>
												<p class="caption font-weight-bold mb-0" style="color: #F44336;">{{ pendingResponseStatus === 4 ? 'Rechazar solicitud' : 'Cancelar solicitud' }}</p>
											</div>
											<p class="caption mb-2" style="color: #777;">
												{{ pendingResponseStatus === 4 ? 'Esta acción rechazará la solicitud. Ingresa el motivo del rechazo.' : 'Esta acción cancelará la solicitud enviada al cliente. Ingresa el motivo de la cancelación.' }}
											</p>
											<v-textarea
												v-model="observation"
												outlined
												dense
												rows="2"
												:placeholder="pendingResponseStatus === 4 ? 'Motivo del rechazo...' : 'Motivo de la cancelación...'"
												hide-details="auto"
												background-color="white"
											></v-textarea>
											<div class="d-flex justify-end mt-1" style="gap: 8px;">
												<v-btn
													small
													text
													style="text-transform: none; letter-spacing: 0; color: #777;"
													@click="showCancellationForm = false; observation = ''; pendingResponseStatus = null"
												>
													Volver
												</v-btn>
												<v-btn
													small
													depressed
													dark
													style="text-transform: none; letter-spacing: 0; background-color: #F44336;"
													@click="confirmCancellation"
												>
													<v-icon small left>mdi-close-circle-outline</v-icon>
													{{ pendingResponseStatus === 4 ? 'Confirmar rechazo' : 'Confirmar cancelación' }}
												</v-btn>
											</div>
										</div>
									</div>
								</v-expand-transition>
							</div>

						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {getAdditionalRequestDetail, additionalRequestResponse} from '@/helpers/api/projects'

export default {
  name: 'AdditionalRequirementDetailModal',
  data: () => ({
		indexModal: + new Date(),
		requestDetail: {},
		loading: false,
		observation: '',
		showCancellationForm: false,
		pendingResponseStatus: null
  }),
  computed: {
		userInfo() {
			return this.$store.state.user.userInfo
		},
		isProjectResponsible(){
			return this.userInfo.id === this.requestDetail.project?.responsible_id
		},
		isProjectClient(){
			return this.userInfo.id === this.requestDetail.project?.client_id
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		id(){
			return this.$store.state.projects.additionalRequirementDetailModal?.additional_request_id
		},
		projectName(){
			return this.requestDetail.project?.name || ''
		},
		projectAddress(){
			return this.requestDetail.project?.info?.address?.address || ''
		},
		projectLineNumber(){
			return this.requestDetail.project?.project_line_info?.id || ''
		},
		projectClient(){
			return this.requestDetail.project?.client?.profile?.name + ' ' + this.requestDetail.project?.client?.profile?.lastname || this.requestDetail.project?.client?.name || ''
		},
		currencyLabel(){
			const currencies = {
				1: 'UF',
				2: 'CLP'
			}
			return currencies[this.requestDetail.currency_type] || this.requestDetail.currency_type
		}
  },
  mounted(){
		this.$modal.show('custom_detail_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		if (this.id) {
			this.fetchRequestDetail()
		}
		eventBus.$on('reloadInformationAdditionalRequirement', (data) => {
			if(data.id == this.id){
				this.fetchRequestDetail()
			}
		})
  },
	beforeDestroy() {
		eventBus.$off('reloadInformationAdditionalRequirement')
	},
  methods: {
		openObservationFormForStatus(status) {
			this.observation = ''
			this.pendingResponseStatus = status
			this.showCancellationForm = true
		},
		async fetchRequestDetail(){
			try {
				this.loading = true
				const response = await getAdditionalRequestDetail({additional_request_id: this.id})
				if (response.code === 200) {
					this.requestDetail = response.additional_request || {}
				}
			} catch (error) {
				console.error('Error fetching request detail:', error)
			} finally {
				this.loading = false
			}
		},
		closeModal(){
			this.$store.commit('projects/setAdditionalRequirementDetailModal', null)
    },
		getStatusColor(status){
			const statusColors = {
				1: '#FFA500', // Pendiente
				2: '#9E9E9E', // Cancelada
				3: '#4CAF50', // Aprobada
				4: '#F44336'  // Rechazada
			}
			return statusColors[status] || '#9E9E9E'
		},
		getStatusLabel(status){
			const statusLabels = {
				1: 'Pendiente de Aprobación',
				2: 'Cancelada',
				3: 'Aprobada',
				4: 'Rechazada'
			}
			return statusLabels[status] || status
		},
		async respondToRequest(status){
			try {
				// Si el cliente intenta rechazar, abrir el formulario para exigir observación
				if (status === 4 && this.isProjectClient) {
					this.openObservationFormForStatus(4)
					return
				}

				const payload = {
					additional_request_id: this.requestDetail.id,
					status: status
				}

				const response = await additionalRequestResponse(payload)
				if (response.code === 200) {
					this.fetchRequestDetail()
					this.setMessage({
						message: 'Solicitud actualizada correctamente',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check',
						color: '#4CAF50'
					})
					const data = {additional_request_id: this.requestDetail.id}
					eventBus.$emit('reloadInformation', data)
				}
			} catch (error) {
				console.error('Error updating request:', error)
				this.setMessage({
					message: 'Error al actualizar la solicitud',
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert',
					color: '#F44336'
				})
			}
		},
		async confirmCancellation(){
			try {
				// Validar observación
				if (!this.observation.trim()) {
					const msg = this.pendingResponseStatus === 4 ? 'Por favor ingrese el motivo del rechazo' : 'Por favor ingrese el motivo de la cancelación'
					this.setMessage({
						message: msg,
						title: 'Campo Obligatorio',
						type: 'warning',
						icon: 'mdi-alert',
						color: '#FFA500'
					})
					return
				}

				const payload = {
					additional_request_id: this.requestDetail.id,
					status: this.pendingResponseStatus || 2,
					observation: this.observation
				}

				const response = await additionalRequestResponse(payload)
				if (response.code === 200) {
					const successMessage = payload.status === 4 ? 'Solicitud rechazada correctamente' : 'Solicitud cancelada correctamente'
					this.observation = ''
					this.showCancellationForm = false
					this.pendingResponseStatus = null
					this.fetchRequestDetail()
					this.setMessage({
						message: successMessage,
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check',
						color: '#4CAF50'
					})
					const data = {additional_request_id: this.requestDetail.id}
					eventBus.$emit('reloadInformation', data)
				}
			} catch (error) {
				console.error('Error cancelling request:', error)
				this.setMessage({
					message: 'Error al procesar la solicitud',
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert',
					color: '#F44336'
				})
			}
		},
		toContract(){
			this.closeModal()
			if(this.isProjectResponsible){
				this.$router.push({ name: 'ContractDetail', query: { id: this.requestDetail.project?.contract.id } })
			}
			else if(this.isProjectClient){
				this.$router.push({ name: 'ClientDetail', query: {} })
				setTimeout(() => {
					this.$router.push({ name: 'ClientDetail', query: { ct: this.requestDetail.project?.contract.id } })
				}, 200)
			}
		},
		toProjectCostBreakdown(){
			this.closeModal()
			this.$router.push({ name: 'ProjectCostBreakdown', params: { id: this.requestDetail.project?.id } })
		},
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .detail-section{
    width: 100%;
  }
  .label-text{
    font-size: 12px;
    color: #999;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 6px !important;
  }
  .value-text{
    font-size: 14px;
    color: #524D4D;
    font-weight: 500;
    margin-bottom: 0 !important;
  }
  .value-text.small-text{
    font-size: 13px;
  }
  .message-box{
    background-color: #F5F5F5;
    border-left: 3px solid #524D4D;
    padding: 12px;
    border-radius: 4px;
    min-height: 80px;
  }
	.observation-textarea {
		background-color: #FAFAFA !important;
	}
	.observation-textarea /deep/ .v-field__control {
		background-color: #FAFAFA;
	}
	.v-expand-transition-enter-active,
	.v-expand-transition-leave-active {
		transition: all 0.3s ease;
	}
</style>
